// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2Qhn-","large":"styles_large__2ce17"};